// src/push-client.js
// Push client with consent UI (askUserFirst) + compat loading + token registration + foreground handling
// Exposes named exports, default export and window.pushClient for maximum compatibility.

const VAPID_KEY = "BC5IO3UecnmAVU-gTxiY6MHd7bs8ORtOxbIq0tF50dFuUgIGzsjo9FytUsv9iJHIfMjhavSgUZQ51_O9FQ59mkI";


// Default SW path (change if you use /sw.js)
const SW_PATH = "/firebase-messaging-sw.js";

const STORAGE_KEY = "pushClientConsent";
const REMIND_DAYS = 1;

// small defaults used by old script
const PUSH_IMAGE = "/logo.webp";
const PUSH_HOME_ROUTE = "/";

// --- small helpers ---------------------------------------------------------
function nowMs() {
    return Date.now();
}
function daysSince(ts) {
    return (nowMs() - ts) / (1000 * 60 * 60 * 24);
}
function safeJsonParse(s) {
    try {
        return JSON.parse(s);
    } catch {
        return null;
    }
}

// --- iOS A2HS helpers (from old script) ----------------------------------
function isIos() {
    const ua = navigator.userAgent.toLowerCase();
    const isIpad = /ipad/.test(ua) || (ua.includes("macintosh") && "ontouchend" in document);
    const isIphone = /iphone/.test(ua);
    const isIpod = /ipod/.test(ua);
    return isIpad || isIphone || isIpod;
}
const isInStandalone =
    (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true;

const A2HS_KEY = "iosA2HSConsent";
const A2HS_REMIND_DAYS = 1;

function getA2HSConsent() {
    const saved = localStorage.getItem(A2HS_KEY);
    if (!saved) return null;
    try {
        const data = JSON.parse(saved);
        if (!data.date) return null;
        if (data.allowed === false) {
            const ds = (Date.now() - data.date) / (1000 * 60 * 60 * 24);
            if (ds >= A2HS_REMIND_DAYS) return null;
        }
        return data;
    } catch {
        return null;
    }
}
function saveA2HSConsent(allowed) {
    try {
        localStorage.setItem(A2HS_KEY, JSON.stringify({ allowed, date: Date.now() }));
    } catch { }
}
function showA2HSBanner() {
    return new Promise((resolve) => {
        const wrapper = document.createElement("div");

        // Make wrapper float above bottom nav (improved version from your old script)
        Object.assign(wrapper.style, {
            position: "fixed",
            left: "16px",
            right: "16px",
            bottom: "72px",
            zIndex: "99999",
            display: "block",
            margin: "0 auto",
            maxWidth: "720px",
            borderRadius: "12px",
            background: "#ffffff",
            boxShadow: "0 6px 25px rgba(0,0,0,0.25)",
            padding: "0",
            opacity: "0",
            transition: "opacity .3s, transform .28s",
            transform: "translateY(6px)",
            cursor: "pointer",
            fontSize: "14px",
            lineHeight: "1.4",
            color: "#111",
        });

        const hs_original_html = `
<div style="padding:14px 16px; font-size:14px; line-height:1.4;">
  <strong>Main lancar, tanpa ribet, akses kapan pun & di mana pun</strong>
  <br><br>

  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width:20px;height:20px;display:inline-flex;vertical-align:middle;margin-right:6px;color:#0a84ff;stroke:currentColor;fill:none;">
    <rect x="2" y="6" width="20" height="14" rx="3" stroke-width="1.6"></rect>
    <path d="M12 6 V2" stroke-width="1.6" stroke-linecap="round"></path>
    <path d="M8 6 L12 2 L16 6" stroke-width="1.6" stroke-linecap="round"></path>
  </svg>
  Ketuk bagikan aplikasi ini ke teman-temanmu
  <br>

  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width:20px;height:20px;display:inline-flex;vertical-align:middle;margin-right:6px;color:#34c759;stroke:currentColor;fill:none;">
    <rect x="3" y="3" width="18" height="18" rx="5" stroke-width="1.6"></rect>
    <path d="M12 8 V16" stroke-width="1.6" stroke-linecap="round"></path>
    <path d="M8 12 H16" stroke-width="1.6" stroke-linecap="round"></path>
  </svg>
  Tambahkan ke menu utama
</div>
`;

        wrapper.innerHTML = hs_original_html;
        document.body.appendChild(wrapper);

        // animate in
        requestAnimationFrame(() => {
            wrapper.style.opacity = "1";
            wrapper.style.transform = "translateY(0)";
        });

        const cleanup = () => {
            wrapper.style.opacity = "0";
            wrapper.style.transform = "translateY(6px)";
            setTimeout(() => {
                try {
                    wrapper.remove();
                } catch (e) {
                    /* ignore */
                }
            }, 320);
        };

        wrapper.addEventListener(
            "click",
            () => {
                cleanup();
                if (typeof saveA2HSConsent === "function") {
                    saveA2HSConsent(false);
                }
                resolve(false);
            },
            { once: true }
        );

        // optional: dismiss if user scrolls far (keeps UI tidy)
        const onScroll = () => {
            if (Math.abs(window.scrollY) > 200) {
                cleanup();
                window.removeEventListener("scroll", onScroll);
                resolve(false);
            }
        };
        window.addEventListener("scroll", onScroll);
    });
}

async function initA2HS() {
    if (!isIos() || isInStandalone) return;
    const consent = getA2HSConsent();
    if (consent?.allowed === false) return;
    if (!consent) await showA2HSBanner();
}

// --- Firebase config (from old script) -----------------------------------
const firebaseConfig = {
    apiKey: "AIzaSyCDqQ67oWwqDMReaO55LtrYi22ITxEpgMQ",
    authDomain: "horasbet-32907.firebaseapp.com",
    projectId: "horasbet-32907",
    storageBucket: "horasbet-32907.firebasestorage.app",
    messagingSenderId: "1071808076564",
    appId: "1:1071808076564:web:1bd74dec0e955984b60001",
    measurementId: "G-WH4VHYFPZ5"
};

// --- load compat scripts dynamically --------------------------------------
async function loadFirebaseCompat(version = "10.13.2") {
    if (typeof window !== "undefined" && window.firebase && window.firebase.messaging) return;

    const base = "https://www.gstatic.com/firebasejs";
    const scripts = [
        `${base}/${version}/firebase-app-compat.js`,
        `${base}/${version}/firebase-messaging-compat.js`,
        `${base}/${version}/firebase-analytics-compat.js`,
    ];

    const loadScript = (src) =>
        new Promise((resolve, reject) => {
            const s = document.createElement("script");
            s.src = src;
            s.async = false; // ensure compat scripts run in order
            s.crossOrigin = "anonymous";
            s.onload = () => resolve();
            s.onerror = () => reject(new Error("Failed to load " + src));
            document.head.appendChild(s);
        });

    for (const src of scripts) {
        try {
            await loadScript(src);
        } catch (err) {
            console.warn("loadFirebaseCompat: failed to load", src, err);
        }
    }
}

// --- simple helpers to add head tags (from old script) --------------------
function addHeadTag(tagName, attributes) {
    const element = document.createElement(tagName);
    for (const key in attributes) {
        element.setAttribute(key, attributes[key]);
    }
    document.head.appendChild(element);
}
async function addMetaTag() {
    try {
        addHeadTag("link", {
            rel: "manifest",
            href: "/manifest.json",
        });

        addHeadTag("meta", {
            name: "apple-mobile-web-app-capable",
            content: "yes",
        });

        addHeadTag("meta", {
            name: "apple-mobile-web-app-status-bar-style",
            content: "black-translucent",
        });

        addHeadTag("link", {
            rel: "apple-touch-icon",
            href: PUSH_IMAGE,
        });
    } catch (e) {
        console.warn("[PushClient] addMetaTag failed", e);
    }
}

// --- consent UI (askUserFirst) --------------------------------------------
function askUserFirst() {
    return new Promise((resolve) => {
        const wrapper = document.createElement("div");
        const template = `
  <div id="pushConsentBox" role="dialog" aria-modal="true" style="
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    color: #111;
    padding: 18px 20px;
    border-radius: 12px;
    box-shadow: 0 6px 25px rgba(0,0,0,0.15);
    font-family: system-ui, sans-serif;
    z-index: 2147483647;
    display:flex;
    gap:14px;
    max-width:420px;
    width:calc(100% - 40px);
    opacity:0;
    transition: all .28s ease;
    flex-direction:column;
  ">
    <div style="display:flex; align-items:center; gap:14px;">
      
     <div id="pushImageBox"
     style="width:56px; height:56px; border-radius:8px; overflow:hidden; flex-shrink:0;">
  <img 
    src="/notification.png"
    alt=""
    style="width:100%; height:100%; object-fit:cover; display:block;" 
  />
</div>

      <div style="flex:1">
        <p style="font-size:15px; font-weight:600; margin:0; color:#333">
          HORASBET - Togel & Slot, Hadiah Melimpah
        </p>
        <p style="font-size:13px; color:#777; margin:6px 0 0">
          Cukup klik "AKTIFKAN" untuk promo terbaru
        </p>
      </div>
    </div>

    <div style="display:flex; justify-content:flex-end; gap:8px; margin-top:8px">
      <button id="pushNo" style="background:#fff;color:#666;border:1px solid #ddd;padding:6px 12px;border-radius:6px;cursor:pointer">NANTI</button>
      <button id="pushYes" style="background:#0e82e5;color:#fff;border:none;padding:6px 12px;border-radius:6px;cursor:pointer">AKTIFKAN</button>
    </div>
  </div>
`;
        wrapper.innerHTML = template;
        document.body.appendChild(wrapper);
        const box = wrapper.firstElementChild;
        requestAnimationFrame(() => (box.style.opacity = "1"));

        const cleanup = (result) => {
            box.style.opacity = "0";
            setTimeout(() => {
                try {
                    wrapper.remove();
                } catch { }
                resolve(result);
            }, 300);
        };

        // ESC to cancel
        const onKey = (e) => {
            if (e.key === "Escape") {
                document.removeEventListener("keydown", onKey);
                cleanup(false);
            }
        };
        document.addEventListener("keydown", onKey, { passive: true });

        const yes = box.querySelector("#pushYes");
        const no = box.querySelector("#pushNo");
        try {
            yes.focus();
        } catch { }

        yes.onclick = () => {
            document.removeEventListener("keydown", onKey);
            cleanup(true);
        };
        no.onclick = () => {
            document.removeEventListener("keydown", onKey);
            cleanup(false);
        };
    });
}

// --- alternate push consent UI (old askPushConsent preserved) ------------
async function askPushConsent() {
    return new Promise((resolve) => {
        const wrapper = document.createElement("div");
        const original_temp = `
      <div id="pushConsentBox" style="
        position: fixed;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
        color: #111;
        padding: 18px 20px 14px;
        border-radius: 12px;
        box-shadow: 0 6px 25px rgba(0,0,0,0.15);
        font-family: system-ui, sans-serif;
        z-index: 2147483647;
        display: flex;
        align-items: flex-start;
        gap: 14px;
        max-width: 420px;
        width: calc(100% - 40px);
        opacity: 0;
        transition: all 0.4s ease;
        flex-direction: column;
      ">
        <div style="display:flex; align-items:center; gap:14px; width:100%;">
          <img src="#" alt="Notification Icon" width="56" height="56" style="border-radius:8px; flex-shrink:0;">
          <div style="flex:1;">
            <p style="font-size:15px; font-weight:600; margin:0; color:#333;">
              Hi, Turn on your notification to get information from us!
            </p>
            <p style="font-size:13px; color:#777; margin-top:4px;">
              There will be many discount/promo for you
            </p>
          </div>
        </div>

        <div style="display:flex; justify-content: flex-end; gap:8px; width:100%;">
          <button id="pushNo" style="background:#fff; color:#666; border:1px solid #ddd; padding:6px 14px; border-radius:6px; cursor:pointer; font-weight:500; font-size:13px;">NANTI</button>
          <button id="pushYes" style="background:#0e82e5; color:#fff; border:none; padding:6px 14px; border-radius:6px; cursor:pointer; font-weight:500; font-size:13px;">AKTIFKAN</button>
        </div>
      </div>
    `;
        wrapper.innerHTML = original_temp;
        document.body.appendChild(wrapper);
        const box = wrapper.firstElementChild;
        requestAnimationFrame(() => (box.style.opacity = "1"));

        const cleanup = () => {
            box.style.opacity = "0";
            setTimeout(() => wrapper.remove(), 300);
        };

        box.querySelector("#pushYes").onclick = () => {
            cleanup();
            resolve(true);
        };
        box.querySelector("#pushNo").onclick = () => {
            cleanup();
            resolve(false);
        };
    });
}

// --- consent storage ------------------------------------------------------
function saveConsent(allowed) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ allowed, date: nowMs() }));
    } catch (e) {
        console.warn("saveConsent failed", e);
    }
}
function getConsent() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const obj = safeJsonParse(raw);
        if (!obj || typeof obj !== "object") return null;
        if (obj.allowed === false) {
            if (!obj.date) return null;
            if (daysSince(obj.date) >= REMIND_DAYS) return null;
        }
        return obj;
    } catch (e) {
        return null;
    }
}

// --- SW registration (idempotent) ----------------------------------------
async function ensureServiceWorker(path = SW_PATH) {
    if (!("serviceWorker" in navigator)) throw new Error("No serviceWorker support");
    try {
        const existing = await navigator.serviceWorker.getRegistration();
        if (existing) return existing;
    } catch (e) {
        // ignore
    }
    return navigator.serviceWorker.register(path);
}

// --- token obtain (compat variations) ------------------------------------
async function obtainToken(registration) {
    let messaging = typeof window !== "undefined" ? window.firebaseMessaging : null;
    if (!messaging && window.firebase && window.firebase.messaging) {
        try {
            messaging = window.firebase.messaging();
            window.firebaseMessaging = messaging;
        } catch { }
    }
    if (!messaging) throw new Error("firebaseMessaging not available");
    try {
        const token = await messaging.getToken({ vapidKey: VAPID_KEY, serviceWorkerRegistration: registration });
        return token || null;
    } catch (err) {
        // fallback to callback style
        return await new Promise((resolve) => {
            try {
                messaging.getToken({ vapidKey: VAPID_KEY, serviceWorkerRegistration: registration }, (t) => resolve(t || null));
            } catch (e) {
                resolve(null);
            }
        });
    }
}

// --- foreground message handler that shows notification via SW reg --------
async function showForegroundNotification(payload) {
    try {
        const reg = await navigator.serviceWorker.getRegistration(SW_PATH);
        if (!reg) {
            console.warn("[PushClient] SW not found to show notification");
            return;
        }
        const { notification = {}, data = {} } = payload || {};
        const title = notification?.title || data?.title || "Notification";
        const body = notification?.body || data?.body || "";
        const icon = notification?.icon || data?.icon || "/logo192.png";
        const clickAction = notification?.click_action || data?.click_action || "/";
        reg.showNotification(title, {
            body,
            icon,
            data: { clickAction },
        });
    } catch (err) {
        console.warn("[PushClient] showForegroundNotification error", err);
    }
}

// --- core auto-register (combines initPushClient behavior) ----------------
/**
 * Options:
 *   retries: retry count for permission requests
 *   delay: base delay (ms) for retries
 *   firebaseConfig: optional firebase config object to initialize if not already
 *   requireConsent: boolean (default true)
 *   swPath: service worker path (default SW_PATH)
 */
async function autoRegisterForPush({
    retries = 2,
    delay = 2000,
    firebaseConfig: cfg = null,
    requireConsent = true,
    swPath = SW_PATH,
} = {}) {
    if (typeof window === "undefined") return null;

    // ensure helpful meta tags are present (old script behavior)
    try {
        await addMetaTag();
    } catch (e) {
        /* ignore */
    }

    // If iOS Safari non-standalone—show A2HS and skip push
    if (isIos() && !isInStandalone) {
        try {
            await initA2HS();
        } catch (e) { }
        console.log("[PushClient] iOS Safari detected; skipping push registration (A2HS flow shown)");
        return null;
    }

    const consent = getConsent();
    if (consent?.allowed === false) {
        console.log("[PushClient] previously declined (remind later)");
        return null;
    }

    // Show consent UI by default when no saved consent and requireConsent===true
    if (!consent && requireConsent) {
        try {
            const userWants = await askUserFirst();
            if (!userWants) {
                saveConsent(false);
                return null;
            }
        } catch (err) {
            console.warn("[PushClient] askUserFirst error", err);
        }
    }

    // Load compat scripts
    try {
        await loadFirebaseCompat();
    } catch (err) {
        console.warn("[PushClient] loadFirebaseCompat failed", err);
    }

    // Initialize firebase compat if provided and not init'd
    try {
        const toInit = cfg || firebaseConfig;
        if (typeof window !== "undefined" && window.firebase) {
            try {
                if (toInit && (!window.firebase.apps || window.firebase.apps.length === 0)) {
                    window.firebase.initializeApp(toInit);
                }
                if (!window.firebaseMessaging && window.firebase.messaging) {
                    window.firebaseMessaging = window.firebase.messaging();
                }
            } catch (initErr) {
                // ignore if already initialized
            }
        } else {
            // If firebase global absent but we have config, attempt init (after load)
            try {
                if (toInit && typeof window !== "undefined") {
                    window.firebase.initializeApp(toInit);
                    if (window.firebase && window.firebase.messaging) {
                        window.firebaseMessaging = window.firebase.messaging();
                    }
                }
            } catch (e) {
                console.warn("[PushClient] firebase init failed", e);
            }
        }
    } catch (err) {
        console.warn("[PushClient] firebase init check failed", err);
    }

    // If permission already granted, try to get token
    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
        try {
            const reg = await ensureServiceWorker(swPath);
            const token = await obtainToken(reg);
            if (token) saveConsent(true);
            return token;
        } catch (err) {
            console.warn("[PushClient] autoRegister (granted) failed", err);
            return null;
        }
    }

    // If denied, nothing to do
    if (typeof Notification !== "undefined" && Notification.permission === "denied") {
        console.warn("[PushClient] Notification permission denied");
        return null;
    }

    // Try requesting permission with retries
    for (let attempt = 0; attempt < retries; attempt++) {
        try {
            const perm = await Notification.requestPermission();
            if (perm !== "granted") {
                console.warn(`[PushClient] permission not granted (attempt ${attempt + 1}):`, perm);
                if (perm === "denied") {
                    saveConsent(false);
                    return null;
                }
                // else retry after delay
            } else {
                const reg = await ensureServiceWorker(swPath);
                const token = await obtainToken(reg);
                if (token) {
                    saveConsent(true);
                    return token;
                }
                return null;
            }
        } catch (err) {
            console.warn("[PushClient] permission/token attempt failed", err);
        }
        await new Promise((r) => setTimeout(r, delay * (attempt + 1)));
    }

    console.warn("[PushClient] autoRegisterForPush exhausted attempts");
    return null;
}

/**
 * Register listener for foreground messages.
 * callback receives the payload. Default behavior shows a notification via SW.
 */
function listenForForegroundMessages(cb) {
    if (typeof window === "undefined") return;
    if (!window.firebaseMessaging || !window.firebaseMessaging.onMessage) {
        console.warn("[PushClient] firebaseMessaging.onMessage not available");
        return;
    }
    try {
        window.firebaseMessaging.onMessage(async (payload) => {
            try {
                await showForegroundNotification(payload);
            } catch (e) {
                console.warn("[PushClient] foreground notify failed", e);
            }
            if (typeof cb === "function") cb(payload);
        });
    } catch (err) {
        console.warn("[PushClient] listenForForegroundMessages error", err);
    }
}

// --- compatibility wrapper: named exports, default, and window global ---
const _pushClientAPI = {
    autoRegisterForPush,
    listenForForegroundMessages,
    askUserFirst,
    askPushConsent,
    saveConsent,
    getConsent,
};

// Attach to window for plain-script / CommonJS interop
try {
    if (typeof window !== "undefined") {
        window.pushClient = window.pushClient || _pushClientAPI;
    }
} catch (e) {
    // ignore in non-browser env
}

// Re-export named exports (single export block)
export { autoRegisterForPush, listenForForegroundMessages, askUserFirst, askPushConsent, saveConsent, getConsent };

// Default export
export default _pushClientAPI;
